import IService from '../IService';

export default IService.extend({
  GET_TRANSLATION: function ({ assetUUID, languageCode }) {
    return new Promise((resolve, reject) => {
      const url = `/api/v1/assets/${assetUUID}/language/${languageCode}/translations`;

      $.ajax({
        url: app.apiUrl(url),
        type: 'GET',

        error: (jqXHR, textStatus) => {
          if (textStatus !== 'abort') {
            reject(this.createError(jqXHR));
          }
        },

        dataType: 'json',
        success: (response) => {
          if (
            response?.originalTranscription?.transcriptionStatus === 'DONE' ||
            response?.originalTranscription?.transcriptionStatus ===
              'UPDATED' ||
            response?.transcriptionStatus === 'DONE' ||
            response?.transcriptionStatus === 'UPDATED'
          ) {
            resolve(response);
          } else {
            reject(response);
          }
        },
      });
    });
  },

  GET: function ({ assetUUID, storyId, languageCode }) {
    return new Promise((resolve, reject) => {
      const url = storyId
        ? `/api/v1/draftStories/${storyId}/assets/${assetUUID}/transcriptions`
        : `/api/v1/assets/${assetUUID}/transcriptions`;

      $.ajax({
        url: app.apiUrl(url),
        type: 'GET',
        data: { languageCode },
        error: (jqXHR, textStatus) => {
          if (textStatus !== 'abort') {
            reject(this.createError(jqXHR));
          }
        },

        dataType: 'json',
        success: (response) => {
          if (
            response?.originalTranscription?.transcriptionStatus === 'DONE' ||
            response?.originalTranscription?.transcriptionStatus ===
              'UPDATED' ||
            response?.transcriptionStatus === 'DONE' ||
            response?.transcriptionStatus === 'UPDATED'
          ) {
            resolve(response);
          } else {
            reject(response);
          }
        },
      });
    });
  },

  POST: function ({ assetUUID, storyId, transcribeSubType }) {
    return new Promise((resolve, reject) => {
      const postData = { languageCode: null };

      if (transcribeSubType === app.transcribeSubType.NARRATION) {
        Object.assign(postData, {
          assetType: 'AUDIO',
          assetSubType: 'NARRATION',
        });
      } else if (transcribeSubType === app.transcribeSubType.VIDEO) {
        Object.assign(postData, {
          assetType: 'VIDEO',
          assetSubType: null,
        });
      } else {
        app.doctorController.report(
          `unknown transcribeSubType: '${transcribeSubType}'`
        );
      }

      const url = storyId
        ? `/api/v1/draftStories/${storyId}/assets/${assetUUID}/transcriptions`
        : `/api/v1/assets/${assetUUID}/transcriptions`; // todo - find real url

      $.ajax({
        url: app.apiUrl(url),
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(postData),

        error: (jqXHR, textStatus) => {
          if (textStatus !== 'abort') {
            reject(this.createError(jqXHR));
          }
        },

        dataType: 'json',
        success: function (response) {
          if (
            'PROCESSING' === response?.status ||
            'DONE' === response?.status
          ) {
            resolve(response.status);
          } else {
            reject({ error: response?.status });
          }
        },
      });
    });
  },

  POST_TRANSLATION: function ({
    assetUUID,
    storyId,
    transcribeSubType,
    languageCode,
  }) {
    return new Promise((resolve, reject) => {
      const url = `/api/v1/assets/${assetUUID}/language/${languageCode}/translations`;

      $.ajax({
        url: app.apiUrl(url),
        type: 'POST',
        contentType: 'application/json',
        // data: JSON.stringify(postData),

        error: (jqXHR, textStatus) => {
          if (textStatus !== 'abort') {
            reject(this.createError(jqXHR));
          }
        },

        dataType: 'json',
        success: function (response) {
          if ('DONE' === response?.status) {
            resolve(response.status);
          } else {
            reject({ error: response?.status });
          }
        },
      });
    });
  },

  PUT: function ({ storyId, assetUUID, tokens }) {
    return new Promise((resolve, reject) => {
      const url = app.apiUrl(
        `/api/v1/draftStories/${storyId}/assets/${assetUUID}/transcriptions`
      );

      $.ajax({
        url: url,
        type: 'PUT',
        contentType: 'application/json',
        data: JSON.stringify({ tokens }),

        error: (jqXHR, textStatus) => {
          if (textStatus !== 'abort') {
            reject(this.createError(jqXHR));
          }
        },

        success: function (response) {
          resolve();
        },
      });
    });
  },

  POST_EMPTY: function ({ storyId, assetUUID, tokens }) {
    return new Promise((resolve, reject) => {
      const postData = {
        assetType: 'AUDIO',
        assetSubType: 'NARRATION',
        languageCode: null,
        tokens,
      };

      $.ajax({
        url: app.apiUrl(
          `/api/v1/draftStories/${storyId}/assets/${assetUUID}/transcriptions/empty`
        ),
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(postData),

        error: (jqXHR, textStatus) => {
          if (textStatus !== 'abort') {
            reject(this.createError(jqXHR));
          }
        },

        dataType: 'json',
        success: function (response) {
          if ('DONE' === response.status) {
            resolve(response.status);
          } else {
            reject({ error: response.status });
          }
        },
      });
    });
  },
});
